import { lazy } from 'react';
const PslInq = lazy(() => import('./pslinq'));

const pslInqRoutes = [
  {
    path: '/pslinq',
    component: PslInq
  }
];

export default pslInqRoutes;